import { DEFAULT_CURRENCY_FORMAT } from '@eventbrite/intl';
import { locationDuck } from '@eventbrite/redux-destination';
import { combineReducers } from 'redux';
import adminReducer from './admin';
import appReducer from './app';
import authReducer from './auth';
import brandReducer from './brand';
import contentReducer from './content';
import locationReducer from './location';
import paginationReducer from './pagination';
import searchReducer from './search';
import shareReducer from './share';
import suggestionsReducer from './suggestions';
import uiReducer from './ui';

const {
    actionTypes: { UPDATE_LOCATION_INFORMATION },
} = locationDuck;

const locationAndSearchInformation = (
    state = {},
    { type, payload }: { type: string; payload?: any },
) => {
    let nextState = state;

    if (type === UPDATE_LOCATION_INFORMATION) {
        const { path, search, location } = payload;

        nextState = {
            ...nextState,
            [path]: {
                search,
                location,
            },
        };
    }

    return nextState;
};

export default combineReducers({
    // routing: d=>d,
    location: locationReducer,
    content: contentReducer,
    brand: brandReducer,
    pagination: paginationReducer,
    auth: authReducer,
    share: shareReducer,
    search: searchReducer,
    suggestions: suggestionsReducer,
    app: appReducer,
    currencyFormat: (state = DEFAULT_CURRENCY_FORMAT) => state,
    locationAndSearchInformation,
    gaSettings: (state = {}) => state,
    botH1: (state = '') => state,
    googleMapsApiKey: (state = '') => state,
    user: (state = {}) => state,
    admin: adminReducer,
    ui: uiReducer,
    shouldShowTrendingSearchPageLink: (state = null) => state,
});
